export const sortList = (data) => {
    return data.sort((a, b) => {
         return a.sort_order - b.sort_order;
     });
}